import { Helmet } from 'react-helmet-async';
import UserProfileView from 'src/sections/account/view';

// ----------------------------------------------------------------------

export default function AccountGeneral() {
  return (
    <>
      <Helmet>
        <title>Account</title>
      </Helmet>
      <UserProfileView/>
    </>
  )
}
